import { InteractionType } from "@azure/msal-browser";
import { useMsalAuthentication } from "@azure/msal-react";
import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import VillageConsoleProvider from "./store/VillageConsoleProvider";
import { Views } from "./views/Views";


const theme = createTheme({
  palette: {
    mode: 'light',
  },
});

const App: React.FC = () => {

  useMsalAuthentication( InteractionType.Redirect );

  return (

    <VillageConsoleProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Views/>
        </BrowserRouter>
      </ThemeProvider>
    </VillageConsoleProvider>

  );

};

export default App;
